import { render, staticRenderFns } from "./CloseLink.vue?vue&type=template&id=4bb60af9&"
import script from "./CloseLink.vue?vue&type=script&lang=js&"
export * from "./CloseLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports